import TitleBlock from '@anm/components/TitleBlock';
import Image from '@anm/components/image/Image';
import { pickWaveLinks } from '@anm/data/links';
import { isHrefLink } from '@anm/data/links/helpers';
import { PickLink } from '@anm/data/links/wave/pickWaveLinks';
import { FC } from 'react';

import vtConfig from '../../../../config';

import CalendarSyncLinksModalWrapper, {
  CalendarSyncLinksWrapper
} from './Wrapper';

export type CalendarSyncLinksProps = {};
const { urls, isProd } = vtConfig();

const linksData = pickWaveLinks({ isProd, waveUrl: urls.wave })([
  'googleWebcal',
  'appleWebcal',
  'outlookWebcal'
]);

const LinkItem: FC<PickLink> = props => {
  if (!isHrefLink(props)) return null;
  const { name, href, title } = props;
  return (
    <a href={href} target="_blank">
      <Image src={`images/webcal/${name}/2x.png`} />
      <span>{title}</span>
    </a>
  );
};

const Links: FC = () => (
  <CalendarSyncLinksWrapper>
    {linksData.map(link => (
      <LinkItem key={link.name} {...link} />
    ))}
  </CalendarSyncLinksWrapper>
);

const CalendarSyncLinks: FC<CalendarSyncLinksProps> = () => (
  <CalendarSyncLinksModalWrapper>
    <TitleBlock
      size="medium"
      color="black"
      title="Get Your Calendars in Sync"
    />

    <Links />
    <p>
      Sync Wave.video social calendar with yours and get inspirational ideas for
      social media daily.
    </p>
  </CalendarSyncLinksModalWrapper>
);

export default CalendarSyncLinks;
